export const redirectScript = redirect_script => {
  const scriptElement = document.createElement('script')
  scriptElement.innerHTML = redirect_script
  document.body.prepend(scriptElement)
}
